export const rankingItems = [
  {
    rank: 1,
    title: '暗夜追凶',
    subtitle: '悬疑剧热度榜首',
    score: '9.2',
    tag: '热度飙升',
    tagClass: 'bg-cinema-accent/20 text-cinema-accent',
    coverUrl: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20crime%20scene%20with%20detective%20silhouette%2C%20noir%20cinematography%2C%20moody%20night%20atmosphere%2C%20film%20noir%20aesthetic%2C%20suspenseful%20urban%20setting%20with%20rain%20soaked%20streets&width=600&height=800&seq=ranking-01&orientation=portrait',
  },
  {
    rank: 2,
    title: '星辰大海',
    subtitle: '科幻巨制新番',
    score: '9.0',
    tag: '新剧上线',
    tagClass: 'bg-cinema-gold/20 text-cinema-gold-light',
    coverUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20with%20starship%20and%20nebula%2C%20cinematic%20lighting%2C%20vast%20galaxy%20background%2C%20futuristic%20spacecraft%2C%20dramatic%20cosmic%20composition&width=600&height=800&seq=ranking-02&orientation=portrait',
  },
  {
    rank: 3,
    title: '长安秘闻录',
    subtitle: '古装悬疑经典',
    score: '8.8',
    tag: '口碑佳作',
    tagClass: 'bg-cinema-gold/20 text-cinema-gold-light',
    coverUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20at%20night%20with%20lanterns%20and%20mysterious%20atmosphere%2C%20Tang%20dynasty%20architecture%2C%20foggy%20courtyard%2C%20historical%20drama%20cinematic%20shot&width=600&height=800&seq=ranking-03&orientation=portrait',
  },
  {
    rank: 4,
    title: '逆流而上',
    subtitle: '都市情感大戏',
    score: '8.7',
    tag: '热议不断',
    tagClass: 'bg-cinema-accent/20 text-cinema-accent',
    coverUrl: 'https://readdy.ai/api/search-image?query=Modern%20cityscape%20at%20sunset%20with%20warm%20golden%20light%2C%20urban%20romance%20drama%20mood%2C%20skyline%20silhouette%2C%20emotional%20contemporary%20Chinese%20drama%20aesthetic&width=600&height=800&seq=ranking-04&orientation=portrait',
  },
  {
    rank: 5,
    title: '边境风云',
    subtitle: '动作大片燃爆',
    score: '8.5',
    tag: '动作强档',
    tagClass: 'bg-cinema-gold/20 text-cinema-gold-light',
    coverUrl: 'https://readdy.ai/api/search-image?query=Intense%20action%20scene%20at%20border%20crossing%2C%20dusty%20desert%20landscape%2C%20dramatic%20tension%2C%20military%20action%20film%20aesthetic%2C%20warm%20earthy%20tones%20with%20explosive%20atmosphere&width=600&height=800&seq=ranking-05&orientation=portrait',
  },
];

export const indexCategories = [
  { icon: 'ri-movie-2-line', label: '悬疑剧场', count: 326, color: 'text-cinema-accent' },
  { icon: 'ri-rocket-2-line', label: '科幻巨制', count: 218, color: 'text-cinema-gold-light' },
  { icon: 'ri-building-2-line', label: '古装经典', count: 457, color: 'text-amber-400' },
  { icon: 'ri-heart-pulse-line', label: '都市情感', count: 389, color: 'text-rose-400' },
  { icon: 'ri-fire-line', label: '动作大片', count: 292, color: 'text-orange-400' },
  { icon: 'ri-emotion-laugh-line', label: '喜剧合集', count: 178, color: 'text-yellow-400' },
  { icon: 'ri-ghost-smile-line', label: '动漫番剧', count: 543, color: 'text-green-400' },
  { icon: 'ri-camera-lens-line', label: '纪录精选', count: 134, color: 'text-sky-400' },
  { icon: 'ri-music-2-line', label: '综艺娱乐', count: 267, color: 'text-pink-400' },
];

export const appEntry = {
  title: '黄瓜影院APP',
  subtitle: '随时随地，高清追剧不缓冲',
  features: ['智能推荐精准匹配', '离线缓存随时观看', '弹幕互动追剧不孤单', '多端同步无缝切换'],
  qrLabel: '扫码下载APP',
  downloadLabel: '立即下载',
  imageUrl: 'https://readdy.ai/api/search-image?query=Mobile%20phone%20displaying%20movie%20streaming%20app%20interface%2C%20modern%20smartphone%20mockup%20with%20cinematic%20film%20poster%20on%20screen%2C%20dark%20themed%20UI%2C%20clean%20minimal%20design%2C%20premium%20app%20presentation&width=600&height=800&seq=app-screen-01&orientation=portrait',
};

export const featureCards = [
  {
    icon: 'ri-search-eye-line',
    title: '智能推荐 · 精准匹配',
    desc: '基于千万用户观影数据，深度学习算法实时分析您的偏好，精准推送符合口味的影视内容。搜索即所得，找片比翻朋友圈还快。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清流畅 · 不缓冲',
    desc: '全站蓝光画质，自适应带宽智能切换清晰度。分布式CDN加速节点遍布全国，确保任何时候打开即播，告别卡顿等待。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量片库 · 即点即播',
    desc: '收录超过10万部影视资源，涵盖电影、电视剧、动漫、综艺、纪录片全品类。每日更新，最新剧集同步上线，永不剧荒。',
  },
];

export const cardItems = [
  {
    tag: '编辑精选',
    tagClass: 'bg-cinema-accent/20 text-cinema-accent',
    title: '2026暑期档必看清单：十部高分新片一网打尽',
    desc: '从悬疑烧脑到温情治愈，这个夏天你不能错过的观影指南全在这里。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Summer%20movie%20marathon%20collection%20with%20film%20strips%20and%20popcorn%2C%20warm%20golden%20hour%20lighting%2C%20cinematic%20atmosphere%2C%20home%20theater%20vibe%2C%20cozy%20evening%20entertainment&width=800&height=500&seq=card-01&orientation=landscape',
  },
  {
    tag: '热播追剧',
    tagClass: 'bg-cinema-gold/20 text-cinema-gold-light',
    title: '《暗夜追凶》第二季：真相背后的真相',
    desc: '豆瓣9.2分神作回归，三大未解之谜即将揭晓，全网推理帖突破百万。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Suspenseful%20detective%20drama%20scene%20with%20evidence%20board%20and%20red%20strings%2C%20noir%20lighting%2C%20crime%20investigation%20mood%2C%20mysterious%20shadow%20figures%2C%20intense%20atmosphere&width=800&height=500&seq=card-02&orientation=landscape',
  },
  {
    tag: '新片速递',
    tagClass: 'bg-green-500/20 text-green-400',
    title: '《星辰大海》导演特辑：打造中国科幻新高度',
    desc: '幕后制作全揭秘，耗资3亿的特效团队如何还原宏大宇宙奇观。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20sci-fi%20film%20production%20with%20green%20screen%20and%20cameras%2C%20futuristic%20set%20design%2C%20film%20crew%20at%20work%2C%20cinematic%20production%20atmosphere&width=800&height=500&seq=card-03&orientation=landscape',
  },
  {
    tag: '经典重温',
    tagClass: 'bg-purple-500/20 text-purple-400',
    title: '《长安秘闻录》服饰考：一针一线皆唐风',
    desc: '从织锦纹样到钗环步摇，古装剧服化道的天花板是如何炼成的。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20Tang%20dynasty%20costume%20details%20with%20intricate%20embroidery%2C%20silk%20fabric%20texture%2C%20golden%20ornaments%2C%20historical%20elegance%2C%20museum%20quality%20display&width=800&height=500&seq=card-04&orientation=landscape',
  },
  {
    tag: '影评精选',
    tagClass: 'bg-cinema-accent/20 text-cinema-accent',
    title: '《逆流而上》为什么戳中了千万都市人的心',
    desc: '从职场挣扎到情感纠葛，这部都市剧拍出了每个人的影子。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Modern%20office%20building%20glass%20reflection%20at%20blue%20hour%2C%20urban%20professional%20life%2C%20contemporary%20Chinese%20city%2C%20emotional%20solitude%2C%20warm%20interior%20light%20through%20windows&width=800&height=500&seq=card-05&orientation=landscape',
  },
  {
    tag: '行业观察',
    tagClass: 'bg-cinema-gold/20 text-cinema-gold-light',
    title: '国产动漫崛起：2026上半年番剧数据盘点',
    desc: '播放量同比增长240%，国产动漫正迎来前所未有的黄金时代。',
    coverUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20style%20with%20vibrant%20colors%2C%20anime%20character%20design%20studio%2C%20illustration%20workspace%20with%20drawing%20tablet%2C%20creative%20production%20atmosphere&width=800&height=500&seq=card-06&orientation=landscape',
  },
];

export const mediaCards = [
  {
    duration: '04:28',
    title: '《暗夜追凶》S2 终极预告',
    views: '892万',
    date: '3天前',
    coverUrl: 'https://readdy.ai/api/search-image?query=Thrilling%20crime%20drama%20trailer%20scene%20with%20dramatic%20lighting%2C%20detective%20in%20action%2C%20intense%20standoff%2C%20cinematic%20wide%20shot%2C%20dark%20urban%20environment&width=800&height=450&seq=media-01&orientation=landscape',
  },
  {
    duration: '08:15',
    title: '《星辰大海》幕后特辑：从概念到银幕',
    views: '567万',
    date: '5天前',
    coverUrl: 'https://readdy.ai/api/search-image?query=Sci-fi%20film%20concept%20art%20studio%20with%20storyboards%20on%20wall%2C%20creative%20director%20working%2C%20futuristic%20design%20sketches%2C%20film%20pre-production%20atmosphere&width=800&height=450&seq=media-02&orientation=landscape',
  },
  {
    duration: '03:42',
    title: '《长安秘闻录》名场面合集',
    views: '1,234万',
    date: '1周前',
    coverUrl: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20palace%20scene%20with%20dramatic%20confrontation%2C%20flowing%20silk%20costumes%2C%20candlelit%20hall%2C%20historical%20drama%20climax%2C%20cinematic%20composition&width=800&height=450&seq=media-03&orientation=landscape',
  },
];

export const updateItems = [
  {
    date: '07-31',
    tag: '新剧上线',
    tagClass: 'bg-green-500/20 text-green-400',
    title: '《迷雾追踪》第三季今日开播',
    desc: '刑侦悬疑剧天花板回归，首集即高能，豆瓣开分9.1。',
  },
  {
    date: '07-30',
    tag: '片库更新',
    tagClass: 'bg-cinema-gold/20 text-cinema-gold-light',
    title: '暑期档片库大更新：新增200+高清资源',
    desc: '涵盖热门电影、经典老片、海外剧集，全站资源突破10万+。',
  },
  {
    date: '07-28',
    tag: '功能升级',
    tagClass: 'bg-sky-500/20 text-sky-400',
    title: '智能推荐算法全面升级',
    desc: '推荐准确率提升35%，找片更快更准，个人首页更懂你。',
  },
  {
    date: '07-25',
    tag: '热门活动',
    tagClass: 'bg-cinema-accent/20 text-cinema-accent',
    title: '「暑期观影季」话题挑战开启',
    desc: '分享你的观影清单，赢取年度会员和限量周边好礼。',
  },
  {
    date: '07-22',
    tag: '片库更新',
    tagClass: 'bg-cinema-gold/20 text-cinema-gold-light',
    title: '20部高分纪录片限时免费开放',
    desc: '自然、历史、科技三大主题，这个夏天来一场知识之旅。',
  },
  {
    date: '07-18',
    tag: '热门活动',
    tagClass: 'bg-cinema-accent/20 text-cinema-accent',
    title: '「暗夜追凶」大结局竞猜火热进行中',
    desc: '参与剧情预测，推理达人就是你，丰厚奖品等你拿。',
  },
  {
    date: '07-15',
    tag: '新剧上线',
    tagClass: 'bg-green-500/20 text-green-400',
    title: '《青春不散场》定档8月8日',
    desc: '年度最受期待校园剧，预约人数已突破300万。',
  },
];

export const carouselItems = [
  {
    title: '悬疑剧场',
    subtitle: '烧脑迷局 · 高能反转',
    desc: '精选百部高分悬疑佳作，从经典本格到社会派推理，每一部都是智商与胆量的双重考验。暗夜追凶、迷雾追踪、长安秘闻录……好戏连台不容错过。',
    cta: '进入悬疑剧场',
    coverUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20office%20with%20case%20files%20and%20evidence%20scattered%2C%20vintage%20desk%20lamp%20casting%20dramatic%20shadows%2C%20noir%20atmosphere%2C%20crime%20scene%20photographs%20on%20wall%2C%20suspenseful%20cinematic%20composition&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '科幻巨制',
    subtitle: '星辰大海 · 无限想象',
    desc: '从硬核科幻到太空歌剧，国产科幻的黄金时代已经到来。星辰大海开启新征程，视觉奇观与深刻哲思并存，带你探索宇宙的终极奥秘。',
    cta: '探索科幻世界',
    coverUrl: 'https://readdy.ai/api/search-image?query=Massive%20futuristic%20space%20station%20orbiting%20a%20colorful%20nebula%2C%20starship%20fleet%20in%20distance%2C%20epic%20cosmic%20scale%2C%20cinematic%20sci-fi%20aesthetic%2C%20dramatic%20lighting%20through%20viewport&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '古装经典',
    subtitle: '千年风雅 · 一剧千年',
    desc: '从巍巍大唐到烟雨江南，古装剧用一针一线还原历史风华。长安秘闻录、大明风华、琅琊旧事……服化道精益求精，故事动人心弦。',
    cta: '品味古装经典',
    coverUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20royal%20palace%20interior%20with%20flowing%20red%20silk%20curtains%2C%20golden%20decorative%20details%2C%20traditional%20lanterns%2C%20historical%20drama%20atmosphere%2C%20warm%20candlelight%20glow&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '动漫番剧',
    subtitle: '国漫崛起 · 次元无限',
    desc: '国产动漫正在书写属于自己的传奇。从热血战斗到治愈日常，制作精良、剧情扎实的国漫佳作层出不穷。追番不停，精彩永不落幕。',
    cta: '追番进行时',
    coverUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20Chinese%20animation%20style%20artwork%20with%20dynamic%20character%20poses%2C%20ink%20wash%20painting%20influence%2C%20colorful%20fantasy%20background%2C%20modern%20anime%20production%20quality%2C%20energetic%20composition&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
];

export const commentItems = [
  {
    avatar: 'L',
    name: '落叶无声',
    time: '2小时前',
    rating: 5,
    content: '黄瓜影院的推荐算法真的绝了！每次打开首页都能发现合口味的片子，比我自己翻豆瓣还准。昨天刚看完《暗夜追凶》，今天首页就推了类似风格的《迷雾追踪》，一口气追了6集，根本停不下来。',
    likes: 326,
  },
  {
    avatar: 'M',
    name: '沐风而行',
    time: '昨天 21:38',
    rating: 5,
    content: '作为一个资深追剧党，试过很多平台，黄瓜影院的片库是真的全。很多冷门老片在这里都能找到高清资源，而且播放流畅度没话说。蓝光画质直接投屏到电视上，观影体验拉满。',
    likes: 189,
  },
  {
    avatar: '星',
    name: '星辰旅人',
    time: '昨天 18:12',
    rating: 4,
    content: '用了半年了，从找片到观影一气呵成。智能推荐越来越懂我的口味，页面也没广告弹窗，干干净净看剧的感觉太好了。希望后续能增加更多的海外剧集资源。',
    likes: 142,
  },
];

export const contactInfo = {
  title: '联系我们',
  subtitle: '资源反馈 · 合作咨询 · 问题建议',
  desc: '如果您在使用过程中遇到任何问题，或有资源需求、合作意向，欢迎通过以下方式联系我们。我们的团队将在24小时内回复您的反馈。',
  methods: [
    { icon: 'ri-mail-line', label: '官方邮箱', value: 'feedback@huanggua.tv' },
    { icon: 'ri-wechat-line', label: '微信公众号', value: '黄瓜影院' },
    { icon: 'ri-message-2-line', label: '在线反馈', value: '点击提交反馈表单' },
  ],
};

export const faqItems = [
  {
    q: '黄瓜影院需要付费吗？',
    a: '黄瓜影院目前全部内容均为免费观看，无需任何付费会员即可畅享海量片库。我们致力于为用户提供免费、高清、流畅的影视搜索和在线观看服务。',
  },
  {
    q: '为什么有些影片加载比较慢？',
    a: '影片加载速度受网络环境和当前时段影响。黄瓜影院采用分布式CDN加速，绝大多数地区均可实现流畅播放。如遇卡顿，建议切换清晰度或稍后重试。',
  },
  {
    q: '智能推荐是如何工作的？',
    a: '我们的智能推荐系统基于您的浏览记录、搜索历史和观看偏好，通过深度学习算法实时分析，为您精准匹配可能感兴趣的影视内容。使用越多，推荐越准。',
  },
  {
    q: '如何在手机上使用黄瓜影院？',
    a: '您可以直接在手机浏览器中访问黄瓜影院，或下载我们的APP获得更佳的移动端体验。APP支持离线缓存、弹幕互动和多端同步功能。',
  },
  {
    q: '资源会定期更新吗？',
    a: '是的。黄瓜影院的片库每日更新，最新剧集和热门电影通常在播出后24小时内上线。您可以在首页「动态速递」模块查看最新更新内容。',
  },
];

export const topicTags = [
  { tag: '暗夜追凶', count: '128万', hot: true },
  { tag: '暑期档', count: '96万', hot: true },
  { tag: '悬疑剧', count: '85万', hot: true },
  { tag: '星辰大海', count: '73万', hot: false },
  { tag: '国产科幻', count: '61万', hot: true },
  { tag: '古装剧', count: '58万', hot: false },
  { tag: '追剧指南', count: '52万', hot: false },
  { tag: '高分电影', count: '47万', hot: false },
  { tag: '动漫推荐', count: '41万', hot: false },
  { tag: '影评精选', count: '36万', hot: false },
];

export const aboutInfo = {
  title: '关于黄瓜影院',
  paragraphs: [
    '黄瓜影院创立于2023年，是一个专注于影视搜索与在线观看的综合平台。我们以"快速找片、精准推荐、高清流畅"为核心追求，致力于为中国影视爱好者提供最优质的观影体验。',
    '平台收录超过10万部影视资源，涵盖电影、电视剧、动漫、综艺、纪录片等全品类内容。借助自主研发的智能推荐引擎，黄瓜影院能够根据每位用户的独特口味精准匹配内容，让找片不再是一件难事。',
    '我们拥有一支热爱影视的技术团队，持续优化搜索算法与播放体验，确保每一帧画面都流畅清晰。未来，黄瓜影院将继续拓展内容边界，用技术让观影变得更简单、更美好。',
  ],
  stats: [
    { value: '10万+', label: '收录资源' },
    { value: '3000万+', label: '月活用户' },
    { value: '99.9%', label: '播放成功率' },
    { value: '24h', label: '更新周期' },
  ],
};

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '专题合集', href: '#index' },
  { label: 'APP下载', href: '#app' },
  { label: '精彩推荐', href: '#media' },
  { label: '热门话题', href: '#topics' },
  { label: '关于我们', href: '#about' },
];

export const footerLinks = {
  columns: [
    {
      title: '快速导航',
      links: [
        { label: '热度榜单', href: '#ranking' },
        { label: '专题合集', href: '#index' },
        { label: '精彩推荐', href: '#media' },
        { label: '动态速递', href: '#updates' },
        { label: '焦点专题', href: '#carousel' },
        { label: '常见问答', href: '#faq' },
      ],
    },
    {
      title: '内容分类',
      links: [
        { label: '悬疑剧场', href: '#index' },
        { label: '科幻巨制', href: '#index' },
        { label: '古装经典', href: '#index' },
        { label: '都市情感', href: '#index' },
        { label: '动作大片', href: '#index' },
        { label: '动漫番剧', href: '#index' },
      ],
    },
    {
      title: '关于平台',
      links: [
        { label: '关于我们', href: '#about' },
        { label: '联系我们', href: '#contact' },
        { label: 'APP下载', href: '#app' },
        { label: '读者评论', href: '#comments' },
        { label: '热门话题', href: '#topics' },
      ],
    },
  ],
};